
import { AccountingChart } from "../../classes"

const AccountingChartModule = {
  namespaced: true,
  state: {
    accountingCharts: []
  },
  mutations: {
    setAccountingCharts(state, charts) {
      state.accountingCharts = charts || []
    },
    addAccountingCharts: (state, charts) => {
      state.accountingCharts.push(charts);
    },
    updateAccountingCharts: (state, charts) => {
      if (charts && state.accountingCharts) {
        let index = state.accountingCharts.findIndex(
          i => i.objectId === charts.objectId
        );
        state.accountingCharts[index] = charts;
      }
    }
  },
  actions: {
    getAccountingCharts: async ({ commit }, projectId) => {
      try{
        const data = await AccountingChart.getAccountingCharts(projectId)
        commit("setAccountingCharts", data)
        return data
      }catch(error){
        throw error
      }
    },
    createAccountingChart: async ({ commit }, formData) => {
      try {
        const data = await AccountingChart.createAccountingChart(formData);
        commit("addAccountingCharts", data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    updateAccountingChart: async ({ commit }, formData) => {
      try {
        const data = await AccountingChart.updateAccountingChart(formData);
        commit("updateAccountingCharts", data);
        return data;
      } catch (error) {
        throw error;
      }
    },
  },
  getters: {

  },
};
export default AccountingChartModule;
